<div class="left-right-space group-in-tab">
    <div class="flex-between mb-1">
        <div class="d-flex ms-auto">
            <button
                type="button"
                class="btn-list-icon ms-2"
                [pTooltip]="translate?.general.buttons.refresh.singular"
                tooltipPosition="bottom"
                id="btn_UserShiftsRefresh"
                (click)="getRefresh()">
                <i class="fa-regular fa-arrows-rotate"></i>
            </button>
            <div class="p-inputgroup search ms-2">
                <span class="p-input-icon-right">
                    <input
                        type="text"
                        class="w-100"
                        pInputText
                        autocomplete="off"
                        id="input_UserShiftsSearchField"
                        [placeholder]="translate?.general.buttons.search.singular"
                        (keydown.enter)="quickSearch()"
                        [(ngModel)]="searchValue"
                        (keyup)="onSearchCheck()" />
                    <i
                        *ngIf="searchValueData"
                        class="p-autocomplete-clear-icon pi pi-times"
                        id="btn_UserShiftsSearchClear"
                        (click)="onClear()"></i>
                </span>
                <button
                    type="button"
                    pButton
                    icon="fa-regular fa-magnifying-glass"
                    id="btn_UserShiftsSearch"
                    (click)="quickSearch()"></button>
            </div>
            <p-button
                *ngIf="create"
                type="button"
                [label]="translate?.general.buttons.assign.singular || 'Assign'"
                icon="fa-regular fa-user-plus"
                id="btn_UserShiftsAssign"
                styleClass="ms-2 h-32"
                (onClick)="openAssign()"></p-button>
        </div>
    </div>

    <div *ngIf="noRecords" class="h-100-151px">
        <app-no-records-available></app-no-records-available>
    </div>

    <div class="display-table d-flex h-100-100px" [hidden]="noRecords">
        <div class="table-space ag-grid-table-full h-100" style="height: 100%;" [hidden]="noRecords">
            <ag-grid-angular
                #agGrid
                [headerHeight]="33"
                [rowHeight]="27"
                style="height: 100%;"
                class="ag-theme-balham"
                [columnDefs]="columnDefs"
                [gridOptions]="gridOptions"
                [defaultColDef]="defaultColDef"
                [pagination]="false"
                [rowData]="rowData"
                [suppressDragLeaveHidesColumns]="true"
                [allowContextMenuWithControlKey]="false"
                [getContextMenuItems]="getContextMenuItems"
                [components]="frameworkComponents"
                (gridReady)="onGridReady($event)"
                (cellClicked)="onShiftTypeClicked($event)"
                [suppressMultiSort]="false"
                [overlayNoRowsTemplate]="overlayNoRowsTemplate"></ag-grid-angular>

            <div class="col-12">
                <p class="ag-record-row-summary-panel padds text-end" id="label_UserShiftsTableRec">
                    {{ totalRecord }}&nbsp;{{ translate?.general.messages.records }}
                </p>
            </div>
        </div>
    </div>
</div>
